import React, { useEffect, useMemo, useState } from "react";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { MRT_Localization_PT_BR } from "material-react-table/locales/pt-BR";
import "./style.scss";
import { GetApi } from "../services/auth";
import { isValid } from "../services/utils";
import { Button } from "src/Components/customInput";

import { ReactComponent as Erase } from "src/Assets/Icons/erase.svg";

export default function Historico({ darkMode }) {
  const [data, setData] = useState([]);

  const tableTheme = useMemo(() => {
    return createTheme({
      palette: {
        mode: darkMode ? "dark" : "light",
        primary: { main: darkMode ? "#90caf9" : "#1976d2" },
        background: { default: darkMode ? "#121212" : "#ffffff" },
        text: { primary: darkMode ? "#ffffff" : "#000000" },
      },
      typography: {
        button: { textTransform: "none", fontSize: "1rem" },
      },
      components: {
        MuiTooltip: {
          styleOverrides: {
            tooltip: { fontSize: "1.1rem" },
          },
        },
        MuiSwitch: {
          styleOverrides: {
            thumb: {
              color: darkMode ? "#ffffff" : "#000000",
            },
          },
        },
      },
    });
  }, [darkMode]);

  const columns = useMemo(
    () => [
      { accessorKey: "usuario", header: "Usuário" },
      { accessorKey: "acao", header: "Ação" },
      { accessorKey: "detalhes", header: "Detalhes" },
      { accessorKey: "data", header: "Data e Hora" },
    ],
    []
  );

  useEffect(() => {
    if (!isValid(data)) {
      GetApi("historico")
        .then((res) => {
          setData(res?.data?.vendas);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, []);

  return (
    <div className="Historico">
      <div className="controls">
        <Button ClassName="icon">
          <Erase /> Limpar Historico
        </Button>
      </div>

      <ThemeProvider theme={tableTheme}>
        <MaterialReactTable
          key={darkMode ? "dark" : "light"}
          columns={columns}
          data={data}
          enableRowSelection={false}
          enableGlobalFilter={true}
          enableColumnOrdering={false}
          initialState={{ density: "spacious" }}
          localization={MRT_Localization_PT_BR}
        />
      </ThemeProvider>
    </div>
  );
}
